import React, { useState } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  Checkbox,
  FormControlLabel,
  Stepper,
  Step,
  StepLabel,
  Typography,
  Box,
} from "@mui/material";
import { Snackbar, Alert } from "@mui/material";

const ServiceImportForm = ({
  open,
  onClose,
  importService,
  selectedServiceList,
  setSelectedServiceList,
  onSubmit,
}) => {
  const [activeStep, setActiveStep] = useState(0);

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const steps = ["Select Services", "Review Selection"];

  const handleServiceSelection = (service) => {
    if (!service || !service.id) return;

    setSelectedServiceList((prev) => {
      const exists = prev.includes(service.id);
      return exists
        ? prev.filter((id) => id !== service.id)
        : [...prev, service.id];
    });
  };

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleSubmit = () => {
    if (!selectedServiceList || selectedServiceList.length === 0) return;
    setSelectedServiceList(selectedServiceList);
    onClose();
    onSubmit();
  };

  return (
    <>
      <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
        <DialogTitle style={{ color: "#ff4d4d" }}>Service Import</DialogTitle>
        <DialogContent>
          <Stepper activeStep={activeStep} alternativeLabel>
            {steps.map((label, index) => (
              <Step key={label}>
                <StepLabel
                  sx={{
                    "& .MuiStepLabel-label": {
                      color: activeStep === index ? "#ff4d4d" : "gray",
                    },
                    "& .MuiStepIcon-root": {
                      color: activeStep === index ? "#ff4d4d" : "gray",
                    },
                    "& .MuiStepIcon-text": {
                      fill: "white",
                    },
                  }}
                >
                  {label}
                </StepLabel>
              </Step>
            ))}
          </Stepper>

          <Box mt={2}>
            {activeStep === 0 && (
              <div>
                {importService &&
                  importService.map((category) => (
                    <div key={category.id}>
                      <Typography
                        variant="p"
                        style={{ marginTop: "10px", color: "#1976d2" }}
                      >
                        {category.name}
                      </Typography>
                      <Box ml={2}>
                        {category.services &&
                          category.services.map((service) => (
                            <FormControlLabel
                              key={service.id}
                              control={
                                <Checkbox
                                  checked={selectedServiceList.includes(
                                    service.id
                                  )}
                                  onChange={() =>
                                    handleServiceSelection(service)
                                  }
                                />
                              }
                              label={service.service_name}
                            />
                          ))}
                      </Box>
                    </div>
                  ))}
              </div>
            )}
            {activeStep === 1 && (
              <div>
              <Typography variant="h6">Review Selection</Typography>
              <ul>
                {selectedServiceList.map((serviceId) => {
                  // Find the service object that matches the selected ID
                  const service = importService
                    .flatMap(category => category.services)
                    .find(service => service.id === serviceId);
          
                  return service ? <li key={service.id}>{service.service_name}</li> : null;
                })}
              </ul>
            </div>
            )}
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            disabled={activeStep === 0}
            onClick={handleBack}
            variant="contained"
            color="secondary"
          >
            Back
          </Button>
          {activeStep === steps.length - 1 ? (
            <Button onClick={handleSubmit} variant="contained" color="success">
              Submit
            </Button>
          ) : (
            <Button onClick={handleNext} variant="contained" color="primary">
              Next
            </Button>
          )}
        </DialogActions>
      </Dialog>
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={() => setSnackbar({ ...snackbar, open: false })}
          severity={snackbar.severity}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default ServiceImportForm;

// import React, { useState, useEffect, useMemo } from "react";
// import axios from "axios";
// import {
//   Dialog,
//   DialogActions,
//   DialogContent,
//   DialogTitle,
//   Button,
//   Checkbox,
//   FormControlLabel,
//   FormGroup,
//   Divider,
// } from "@mui/material";
// import { baseUrl } from "../../../../../network/constants/constants";
// import AppConstants from "../../../../AppConstants";
// import { getConfig } from "../../../../../network/auth";
// import { Snackbar, Alert } from "@mui/material";

// const ServiceImportForm = ({ open, onClose, importService, fetchServices }) => {
//   const [selectedCategories, setSelectedCategories] = useState([]);
//   const [selectedServices, setSelectedServices] = useState([]);
//   const [selectAll, setSelectAll] = useState(false);
//   const [snackbar, setSnackbar] = useState({
//     open: false,
//     message: "",
//     severity: "success",
//   });

//   const config = useMemo(() => {
//     return getConfig();
//   }, []);

//   let bID = localStorage.getItem(AppConstants.business_id);
//   const handleSelectAll = () => {
//     if (selectAll) {
//       setSelectedCategories([]);
//       setSelectedServices([]);
//     } else {
//       setSelectedCategories(importService.map((category) => category.id));
//       setSelectedServices(
//         importService.flatMap((category) =>
//           category.services.map((service) => service.id)
//         )
//       );
//     }
//     setSelectAll(!selectAll);
//   };

//   const handleCategoryChange = (categoryId, services) => {
//     if (selectedCategories.includes(categoryId)) {
//       setSelectedCategories(
//         selectedCategories.filter((id) => id !== categoryId)
//       );
//       setSelectedServices(
//         selectedServices.filter(
//           (serviceId) => !services.some((service) => service.id === serviceId)
//         )
//       );
//     } else {
//       setSelectedCategories([...selectedCategories, categoryId]);
//       setSelectedServices([
//         ...selectedServices,
//         ...services.map((service) => service.id),
//       ]);
//     }
//   };

//   const handleServiceChange = (serviceId, categoryId) => {
//     const newSelectedServices = selectedServices.includes(serviceId)
//       ? selectedServices.filter((id) => id !== serviceId)
//       : [...selectedServices, serviceId];

//     setSelectedServices(newSelectedServices);

//     const categoryServices = importService
//       .find((category) => category.id === categoryId)
//       .services.map((service) => service.id);

//     if (categoryServices.every((id) => newSelectedServices.includes(id))) {
//       setSelectedCategories((prev) => [...prev, categoryId]);
//     } else {
//       setSelectedCategories((prev) => prev.filter((id) => id !== categoryId));
//     }
//   };

//   useEffect(() => {
//     setSelectAll(
//       selectedCategories.length === importService.length &&
//         selectedServices.length ===
//           importService.flatMap((category) => category.services).length
//     );
//   }, [selectedCategories, selectedServices, importService]);

//   const handleSubmit = async () => {
//     const formattedData = importService
//       .filter((category) => selectedCategories.includes(category.id))
//       .map((category) => ({
//         id: category.id,
//         name: category.name,
//         services: category.services
//           .filter((service) => selectedServices.includes(service.id))
//           .map((service) => ({
//             id: service.id,
//             name: service.service_name,
//           })),
//       }));

//     try {
//       const response = await axios.post(
//         `${baseUrl}businessadmin/create-categories-with-services/${bID}/`,
//         { data: formattedData },
//         config
//       );

//       setSnackbar({
//         open: true,
//         message: response.data.message,
//         severity: "success",
//       });
//       onClose();
//       fetchServices();
//     } catch (error) {
//       console.error("Error posting data:", error);
//     }
//   };

//   return (
//     <>
//       <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
//         <DialogTitle style={{ color: "#ff4d4d" }}>Service Import</DialogTitle>
//         <DialogContent>
//           <FormGroup>
//             <FormControlLabel
//               control={
//                 <Checkbox
//                   checked={selectAll}
//                   onChange={handleSelectAll}
//                   color="primary"
//                 />
//               }
//               label="Select All Categories and Services"
//             />
//             <Divider />
//             {importService.map((category) => (
//               <React.Fragment key={category.id}>
//                 <FormControlLabel
//                   control={
//                     <Checkbox
//                       checked={selectedCategories.includes(category.id)}
//                       onChange={() =>
//                         handleCategoryChange(category.id, category.services)
//                       }
//                       color="primary"
//                     />
//                   }
//                   label={category.name}
//                 />
//                 <Divider />
//                 {category.services.map((service) => (
//                   <FormControlLabel
//                     key={service.id}
//                     control={
//                       <Checkbox
//                         checked={selectedServices.includes(service.id)}
//                         onChange={() =>
//                           handleServiceChange(service.id, category.id)
//                         }
//                         color="primary"
//                       />
//                     }
//                     label={service.service_name}
//                     style={{ marginLeft: 20 }}
//                   />
//                 ))}
//               </React.Fragment>
//             ))}
//           </FormGroup>
//         </DialogContent>
//         <DialogActions>
//           <Button
//             onClick={onClose}
//             variant="contained"
//             color="error"
//             style={{ textTransform: "none" }}
//           >
//             Cancel
//           </Button>
//           <Button
//             onClick={handleSubmit}
//             variant="contained"
//             color="success"
//             style={{ textTransform: "none" }}
//           >
//             Submit
//           </Button>
//         </DialogActions>
//       </Dialog>
//       <Snackbar
//         open={snackbar.open}
//         autoHideDuration={6000}
//         onClose={() => setSnackbar({ ...snackbar, open: false })}
//         anchorOrigin={{ vertical: "top", horizontal: "center" }}
//       >
//         <Alert
//           onClose={() => setSnackbar({ ...snackbar, open: false })}
//           severity={snackbar.severity}
//           sx={{ width: "100%" }}
//         >
//           {snackbar.message}
//         </Alert>
//       </Snackbar>
//     </>
//   );
// };

// export default ServiceImportForm;
